import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function PropertyViewer({ value }) {
    if (!value)
        return null;
    return (_jsxs("div", { className: 'w-full flex items-baseline', children: [_jsx("div", { children: value.name || '' }), _jsx("div", { className: 'ml-2 text-sm text-muted', children: value.type || '' })] }));
}
//# sourceMappingURL=PropertyViewer.js.map